import { render, staticRenderFns } from "./veStuCheckModifyShow.vue?vue&type=template&id=3819820c&scoped=true"
import script from "./veStuCheckModifyShow.vue?vue&type=script&lang=js"
export * from "./veStuCheckModifyShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3819820c",
  null
  
)

export default component.exports